import React from 'react';
import styled from '@emotion/styled';

interface ImageCardProps {
 image: string;
 title: string;
 description: string;
}

const ImageCard: React.FC<ImageCardProps> = ({ image, title, description }) => {
 return (
  <Card>
   <Image src={image} alt={title} />
   <Content>
    <Title>{title}</Title>
    <Description>{description}</Description>
   </Content>
  </Card>
 );
};

export default ImageCard;

const Card = styled.div`
 width: 100%;
 max-width: 600px;
 margin: 0 auto;
 border: 1px solid #e6e6e6;
 border-radius: 16px;
 overflow: hidden;
 background: #ffffff;
 padding: 20px;
`;

const Image = styled.img`
 width: 100%;
 height: auto;
 object-fit: cover;
 border-radius: 16px;
`;

const Content = styled.div`
 padding-top: 18px;
`;

const Title = styled.h3`
 font-size: 24px;
 font-weight: 600;
 color: #282828;
 margin-bottom: 6px;
`;

const Description = styled.p`
 font-size: 18px;
 color: #282828;
 line-height: 1.6;
`;
